import axios, {AxiosResponse} from 'axios';
import {
    ExcelExportResponse,
    SubmissionBatchHistoryDetailRetrieveResponse, SubmissionBatchHistoryRetrieveResponse, SubmissionCaseFilterRetrieveResponse,
    SubmissionCaseHistoryRetrieveResponse, SubmissionCheckListResponse, SubmissionCheckResponse, SubmissionCommentRevisionResponse,
    SubmissionSearchItemsRetrieveResponse, SubmissionSendersRetrieveResponse, SubmissionSubmitResponse
} from '@/model/CommonModel';
import ApiUtils from '@/utils/ApiUtils';

export default class SubmissionApi {
    public static retrieveSenders(sponsorKey: number | string): Promise<SubmissionSendersRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/sender`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveReceivers(sponsorKey: number | string, senderKey: number | string): Promise<any> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/receiver/${senderKey}`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveSearchItems(sponsorKey: number | string): Promise<SubmissionSearchItemsRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/search-items`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static submissionCheck(sponsorKey: number | string, params: any = {}): Promise<SubmissionCheckResponse> {
        return axios
            .post(`/1.1/sponsors/${sponsorKey}/submission/check`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveSubmissionCheckList(sponsorKey: number | string, params: any = {}): Promise<SubmissionCheckListResponse> {
        return axios
            .get(`/1.1/sponsors/${sponsorKey}/submission/cases`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveSubmissionBatchHistory(sponsorKey: number | string, params: any = {}):
        Promise<SubmissionBatchHistoryRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/batch-history?`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static downloadHistoryFile(sponsorKey: number | string, fileKey: number | string): Promise<any> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/files/${fileKey}`, {responseType: 'blob'})
            .then((res: any) => ApiUtils.isFailToFileDownloadResponse(res)
                ? ApiUtils.handleFileDownloadFailResponse(res)
                : ApiUtils.handleFileDownloadSuccessResponse(res));
    }
    
    public static retrieveSubmissionBatchHistoryDetail(sponsorKey: number | string, batchKey: number | string, params: any = {}):
        Promise<SubmissionBatchHistoryDetailRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/history/${batchKey}`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveSubmissionCaseHistory(sponsorKey: number | string, params: any = {}):
        Promise<SubmissionCaseHistoryRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/case-history`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static submissionSubmit(sponsorKey: number | string, params: any = {}): Promise<SubmissionSubmitResponse> {
        return axios
            .put(`/1.0/sponsors/${sponsorKey}/submission/submit`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrievePossibleToSubmission(sponsorKey: string, caseKey: string): Promise<any> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/cases/${caseKey}`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveSubmissionCaseFilter(sponsorKey: string, caseKey: string): Promise<SubmissionCaseFilterRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/casefilter/${caseKey}`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveSubmissionCommentRevisions(sponsorKey: string, batchKey: number): Promise<SubmissionCommentRevisionResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/submission/${batchKey}/comments/audit-trail`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static updateSubmissionCommentRevisions(sponsorKey: string,
                                                   batchKey: number,
                                                   params: any): Promise<SubmissionCommentRevisionResponse> {
        return axios
            .put(`/1.0/sponsors/${sponsorKey}/submission/${batchKey}/comments`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static exportSubmissionHistoriesExcel(): Promise<ExcelExportResponse> {
        return axios
            .get(`/1.0/submission-histories/export`)
            .then((res: AxiosResponse) => res.data);
    }
}
